var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "commentBox", staticClass: "k-panel" }, [
    _c("div", { staticClass: "k-panel__body" }, [
      _vm.reaction !== null
        ? _c("div", { staticClass: "k-reaction" }, [
            _c(
              "a",
              {
                staticClass: "k-reaction__remove",
                attrs: { href: "javascript:;", title: "Zrušit reakci" },
                on: { click: _vm.cancelReaction }
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "k-btn__icon k-btn__icon--rotate",
                    attrs: { role: "img", width: "15", height: "15" }
                  },
                  [
                    _c("use", {
                      attrs: {
                        fill: "currentColor",
                        "xlink:href": "/images/spritesheet.svg#add"
                      }
                    })
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "k-reaction__author" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.reaction.user.name) +
                  " napsal(a):\n            "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "k-reaction__text" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.reaction.content) +
                  "\n            "
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "k-form",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.sendForm($event)
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "k-form__group" },
            [
              _c("label", { staticClass: "k-form__label" }, [
                _vm._v("Komentář")
              ]),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.content,
                    expression: "form.content"
                  }
                ],
                ref: "commentTextarea",
                staticClass: "k-form__textarea",
                attrs: { placeholder: "Zadejte text komentáře" },
                domProps: { value: _vm.form.content },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.form, "content", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _vm.form_errors.content
                ? _c("field-error", [
                    _vm._v(_vm._s(_vm.form_errors.content[0]))
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "k-btn k-btn--primary", attrs: { type: "submit" } },
            [_vm._v("\n                Odeslat komentář\n            ")]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }